
import LessonPuppetSteps from "./LessonPuppetSteps";
import LessonHouseSteps from "./LessonHouseSteps";
import LessonBackgroundSteps from "./LessonBackgroundSteps";
import LessonTheatreSteps from "./LessonTheatreSteps";

export const CourseTheatreRecipe =
    {
      "version": 1,
      "pathname": "theatre",
      "topLine": "course.theatre.topLine",
      "name": "course.theatre.courseName",
      "description" : "course.theatre.courseDescription",
      "imgPath" : "assets/course/theatre/course-thumbnail_theatre_03.jpg",
      "activitypage" : "https://media.catbears.com/course_theatre/activity_pages/thumb_theatre_activitypage.jpg",
      "lessonsCount": 5,
      "id": "course-theatre",
      "lessons": [
        // {
        //   "pathname" : "intro",
        //   "lockedIfNotSubscribed": false,
        //   "type": "SingleStepLesson",
        //   "size": "small",
        //   "name": "general.course-intro", 
        //   "description": "general.course-description", 
        //   "badge": "",
        //   "coinName": "lets-begin",
        //   "id": "course-theatre_intro",
        //   "steps" : [{
        //     // coin-lets-begin
        //                 size : "ROW",
        //                 buttonShape: "coin",
        //                 coinName: "lets-begin",
        //                 name: "general.course-intro", 
        //                 type: "videoTeamwork",
        //                 AnimalName : "koala",
        //                 // requirements: [{name: "activityPage"} ],
        //                 videoThumbnail: "/assets/course/theatre/lesson-thumbnail_puppet.jpeg",
        //                 id:"lets-begin",
        //                 stepItems : [
        //                   { 
        //                     id:"lets-begin_video",
        //                     pageState: "video",
        //                     url: "https://media.catbears.com/course_theatre/The-Catbears-Intro-part1.mp4",
        //                     videoThumbnail: "/assets/course/theatre/intro-thumbnail.jpg",
        //                     isStepGoal: true,
        //                     isSkippable: true
        //                   },
        //                   // {
        //                   //   pageState: "discuss",
        //                   //   img: "/assets/course/theatre/videos-and-thumbnails/alexander-and-mistake.jpg",
        //                   //   discussTitle: "teamworkSkills.idea-behind-mistake.discussTitle",
        //                   // }
        //                 ]
        //               }],
        //   "backgroundColor": "var(--color-skyblue)",
        // },
        {
          "type": "LessonListItem",
          "lockedIfNotSubscribed": false,
          "activityNumber": 1,
          "size": "small",
          "name": "course.theatre.lesson-puppet.name",
          "description" : "course.theatre.lesson-puppet.description",
          "activityPageThumb" : "https://media.catbears.com/course_theatre/activity_pages/thumb_puppet_activitypage.jpg",
          "imgPath" : "assets/course/theatre/videos-and-thumbnails/activity-thumb_puppet.jpg",
          "badge": "",
          "id": "course-theatre_puppet",
          "legacyIds": [],
          "steps" : LessonPuppetSteps,
          "pathname" : "puppet",
          "instructorName" : "instructors.meek",
          "AnimalType" : "koala",
          "backgroundColor": "var(--color-skyblue)",
          "teaserThumbnail": "/assets/course/theatre/videos-and-thumbnails/thumb_puupet_intro.jpg",
          "teaserUrl": "course.theatre.lesson-puppet.steps.intro.videoURL_01",
          "activityPagePDF" : "https://media.catbears.com/course_theatre/activity_pages/catbears_make-a-puppet.pdf",
          "teamworkSkillImgName" : "wheel-of-creation",                                                    
          "teamworkSkillName" : "teamworkSkills.wheel-of-creation.name",                                                    
          "teamworkSkillTodo" : "teamworkSkills.wheel-of-creation.todo"
        },
        { 
          "type": "LessonListItem",
          "lockedIfNotSubscribed": true,
          "activityNumber": 2,
          "size": "small",
          "name": "course.theatre.lesson-house.name",
          "description" : "course.theatre.lesson-house.description",
          "activityPageThumb" : "https://media.catbears.com/course_theatre/activity_pages/thumb_house_activitypage.jpg",
          // "imgPath" : "assets/course/theatre/lesson-thumbnail_house.jpeg",
          "imgPath" : "assets/course/theatre/videos-and-thumbnails/activity-thumb_house.jpg",
          "badge": "",
          "id": "course-theatre_house",
          "legacyIds": [],
          "steps" : LessonHouseSteps,
          "pathname" : "house",
          "instructorName" : "instructors.eden",
          "AnimalType" : "crow",
          "backgroundColor": "#EF86FF",
          "teaserThumbnail": "/assets/course/theatre/videos-and-thumbnails/thumb_house_intro.jpg",
          "teaserUrl": "course.theatre.lesson-house.steps.intro.videoURL_01",
          "activityPagePDF" : "https://media.catbears.com/course_theatre/activity_pages/catbears_build-a-house.pdf",
          "teamworkSkillImgName" : "stop-to-relax",                                                    
          "teamworkSkillName" : "teamworkSkills.stop-to-relax.name",                                                    
          "teamworkSkillTodo" : "teamworkSkills.stop-to-relax.todo"
        },
        {
          "type": "LessonListItem",
          "lockedIfNotSubscribed": true,
          "activityNumber": 3,
          "size": "small",
          "name": "course.theatre.lesson-background.name",
          "description" : "course.theatre.lesson-background.description",
          "activityPageThumb" : "https://media.catbears.com/course_theatre/activity_pages/thumb_background_activitypage.jpg",
          "imgPath" : "assets/course/theatre/videos-and-thumbnails/activity-thumb_background.jpg",
          // "imgPath" : "assets/course/theatre/lesson-thumbnail_background.jpg",
          "badge": "",
          "id": "course-theatre_background",
          "legacyIds": [],
          "steps" : LessonBackgroundSteps,
          "pathname" : "background",
          "instructorName" : "instructors.jordy",
          "AnimalType" : "croc",
          "backgroundColor": "#41B04B",
          "teaserThumbnail": "/assets/course/theatre/videos-and-thumbnails/thumb_background_intro.jpg",
          "teaserUrl": "course.theatre.lesson-background.steps.intro.videoURL_01",
          "activityPagePDF" : "https://media.catbears.com/course_theatre/activity_pages/catbears_background.pdf",
          "teamworkSkillImgName" : "idea-behind-mistake",                                                    
          "teamworkSkillName" : "teamworkSkills.idea-behind-mistake.name",                                                    
          "teamworkSkillTodo" : "teamworkSkills.idea-behind-mistake.todo"
        },
        {
          "type": "LessonListItem",
          "lockedIfNotSubscribed": true,
          "activityNumber": 4,
          "size": "XL",
          "name": "course.theatre.lesson-theatre.name",
          "description" : "course.theatre.lesson-theatre.description",
          "activityPageThumb" : "https://media.catbears.com/course_theatre/activity_pages/thumb_theatre_activitypage.jpg",
          "imgPath" : "assets/course/theatre/videos-and-thumbnails/activity-thumb_theatre.jpg",
          // "imgPath" : "assets/course/theatre/lesson-thumbnail_theatre.jpg",
          "badge": "",
          "id": "course-theatre_theatre",
          "legacyIds": [],
          "steps" : LessonTheatreSteps,
          "pathname" : "theatre",
          "instructorName" : "instructors.angel",
          "AnimalType" : "bunny",
          "backgroundColor": "var(--color-pink)",
          "teaserThumbnail": "/assets/course/theatre/videos-and-thumbnails/thumb_theatre_intro.jpg",
          "teaserUrl": "course.theatre.lesson-theatre.steps.intro.videoURL_01",
          "activityPagePDF" : "https://media.catbears.com/course_theatre/activity_pages/catbears_build-a-theatre.pdf",
          "teamworkSkillImgName" : "create-the-turn",                                                    
          "teamworkSkillName" : "teamworkSkills.create-the-turn.name",                                                    
          "teamworkSkillTodo" : "teamworkSkills.create-the-turn.todo"
        },
        // {
        //   "pathname": "finale",
        //   "lockedIfNotSubscribed": false,
        //   "type": "SingleStepLesson",
        //   "size": "small",
        //   "name": "general.course-whatsNext",
        //   "badge": "",
        //   "coinName": "course-complete",
        //   "id": "course-theatre_finale",
        //   "steps": [{
        //     size: "ROW",
        //     buttonShape: "coin",
        //     coinName: "course-complete",
        //     name: "general.course-whatsNext",
        //     AnimalName: "koala",
        //     videoThumbnail: "/assets/course/theatre/intro-thumbnail.jpg",
        //     id: "course-theatre_finale_step",
        //     stepItems: [
        //       {
        //         id: "course-theatre_finale_ending",
        //         pageState: "ending"
        //       },
        //       {
        //         id: "course-theatre_finale_video",
        //         pageState: "video",
        //         url: "https://media.catbears.com/course_theatre/The-Catbears-Intro-part1.mp4",
        //         videoThumbnail: "/assets/course/theatre/intro-thumbnail.jpg",
        //         isSkippable: true
        //       },
        //       {
        //         id: "course-theatre_finale_feedback",
        //         pageState: "feedback"
        //       },
        //       {
        //         id: "course-theatre_finale_thankyou",
        //         pageState: "discuss",
        //         discussTitle: "general.thankYou",
        //         discussSubtitle: "general.courseFeedback-thankYou-message",
        //         img: "/assets/stickers/foxlove.png",
        //         hideOnReplay: true
        //       },
        //       // {
        //       //   id: "course-theatre_finale_getnotified",
        //       //   pageState: "getNotified",
        //       //   isStepGoal: true,
        //       //   hideOnReplay: false,
        //       //   guestOnly: true
        //       // }
        //     ]
        //   }],
        //   "backgroundColor": "var(--color-skyblue)"
        // },
      ]
  }
  
  export default CourseTheatreRecipe;

